<div class="container" style="border: 2px solid green; height:1900px; max-width: 1270px;">
    <div class="row" style="height: 5%;border: 1px solid blue;">

    </div>
   
    <div class="row" style="height: 95%;border: 1px solid blue;">

    </div>
</div>